//#region Imports
import React, { useEffect, useState } from 'react'
import { SafeAreaView, StyleSheet, useWindowDimensions, ScrollView, Platform, View, Text } from 'react-native';
import MyLeavesScreen from './MyLeavesScreen';
import MonthlyLeaveSchedulerScreen from './MonthlyLeaveSchedulerScreen';
import { useTheme, useNavigation } from '@react-navigation/native';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { useTranslation } from 'react-i18next';
//#endregion

const MyLeavesDetailsScreen = (props) => {

    //#region Const Definitions
    const { width, height } = useWindowDimensions();
    const [currDate, setCurrDate] = useState('');
    const { t } = useTranslation();
    const navigation = useNavigation();
    const { colors } = useTheme()
    const styles = makeStyles(colors, width, height)
    //#endregion

    //#region Use Effect
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    useEffect(() => {
        navigation.setOptions({
            title: t('navigate:ML')
        });
    }, []);
    //#endregion

    return (
        <ScrollView
            style={styles.scroll}
        >
            <SafeAreaView
                style={styles.main}>
                <CustomLabel
                    value={t('navigate:ML')}
                    type='MINORTITLE'
                />
                <SafeAreaView style={styles.row}>
                    <SafeAreaView
                        style={styles.calendar}>
                        <MonthlyLeaveSchedulerScreen
                            setCurrDate={setCurrDate}
                            isMyLeavesScreen={true} />
                    </SafeAreaView>

                    <SafeAreaView
                        style={Platform.OS === 'web' && width > 1200 ? styles.leavesNormal : styles.leaves} >
                        <MyLeavesScreen
                            selectNewLeaveScreen={props.selectNewLeaveScreen}
                            isDashboard={false}
                            currDate={currDate} />
                    </SafeAreaView>
                </SafeAreaView>
            </SafeAreaView>
        </ScrollView>
    )
}


const makeStyles = (colors, width, height) => StyleSheet.create({
    main: {
        flex: 1,
        marginTop: "1%",
        marginLeft: '2%',
        marginRight: '2%',
    },
    scroll: {
        flex: 1,
    },
    calendar: {
        flex: 2,
        marginLeft: Platform.OS === 'web' ? '2%' : '1%',
        maxWidth: width * 0.3, // makes the leave card next to it shorter
        marginRight: Platform.OS === 'web' ? '2%' : '1%',
        marginTop: Platform.OS === 'web' ? '3%' : 0,
    },
    leavesNormal: {
        flex: 1,
        marginTop: 10
        // height < 500 ? height * 40 / 100 : 10,
    },
    leaves: {
        width: width * 95 / 100,
        marginTop: height < 600 ? height * 40 / 100 : 10,
    },
    row: {
        flex: 1,
        flexDirection: width < 1200 ? 'column' : 'row',
    },
    leave: {
        flex: 1,
    },
})

export default MyLeavesDetailsScreen